import { Preview } from "@creatomate/preview";

import type { Audio } from "chq";

import createElement from "./creatomate/createElement";

const addAudio = async (
  preview: Preview, _time: number, url: string, audio: Audio | File
): Promise<string | undefined> => {
  const duration = audio instanceof Audio
    ? Math.min(audio.duration, (preview.state?.duration || 0))
    : preview.state?.duration;
  const auditoTrack = preview.state?.elements?.find(element => element.source.type === "audio");
  const id = await createElement({
    type: "audio",
    name: `Audio - ${audio.name}`,
    source: url,
    duration,
    track: auditoTrack?.track
  }, preview);
  return id;
};

export default addAudio;
